import { Dialog } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { AppDialogTitle } from '../../layout/appDialogTitle';
import { Project } from '../../models/project';
import { Task } from '../../models/task';
import { editTask } from '../../services/api/taskServices';
import { TaskForm } from './taskForm';

interface EditProp {
  isOpen: boolean;
  onClose(): void;
  task: Task | null;
  onRequestSuccessfully(): void;
  project: Project | null;
}

export default function TaskDialogEdit({
  isOpen,
  onClose,
  task,
  project,
  onRequestSuccessfully,
}: EditProp): JSX.Element {
  const [isLoadingRequest, setIsLoadingRequest] = useState<boolean>(false);

  const handleEditTask = useCallback(
    (newTaskDetails) => {
      setIsLoadingRequest(true);
      if (task) {
        const newTask = {
          id: task.id,
          name:
            typeof newTaskDetails.name === 'string'
              ? newTaskDetails.name
              : newTaskDetails.name.label,
          projectId: newTaskDetails.project?.id,
          status: newTaskDetails.status,
          isAMS: newTaskDetails.isAMS,
        };

        editTask(task.id, newTask)
          .then(() => {
            onRequestSuccessfully();

            onClose();
          })
          .finally(() => setIsLoadingRequest(false));
      }
    },

    [task, onRequestSuccessfully, onClose]
  );

  return (
    <>
      <Dialog open={isOpen} sx={{ borderRadius: '5px' }}>
        <AppDialogTitle title="Edit Task" handleClose={onClose} />
        <TaskForm
          onClose={onClose}
          onSubmit={handleEditTask}
          task={task}
          project={project}
          isLoading={isLoadingRequest}
        />
      </Dialog>
    </>
  );
}
